import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpService } from '../shared/services/http.service';


@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  
  httpService=inject(HttpService);

  getGraphType(data: any, cat: string): Observable<any> {
      return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/progress/graph/type`,data);
  }

  getGraphStatus(data: any, cat: string): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/progress/graph/status`,data);
  }

  getProgressTheme(data: any, cat: string): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/progress/graph/theme`,data);
  }


}
